import { lazy } from 'react'

export const GenderVariant1 = lazy(() => import('./v1/GenderVariant1'))
export const GenderVariant2 = lazy(() => import('./v2/GenderVariant2'))
